<!-- Header before-login-header -->
<header class="site-header headerscaleY dark-bg before-login-header" *ngIf="!loginTrue">
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container">
            <a class="navbar-brand" href="javascript:void(0);">
                <img loading="lazy" src="../../../assets/images/updated_logo.png" alt="Logo Image" class="brand-logo" routerLink="/">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#Menubar" aria-controls="Menubar" aria-expanded="false" aria-label="Toggle navigation">
                <i class='gricon gr_ic_bars'></i>
            </button>
            <!-- <div class="collapse navbar-collapse pt-3 pt-lg-0" id="Menubar">
                <ul class="site-navbar-nav navbar-nav my-3 my-lg-0 ps-3">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" href="javascript:void(0);" routerLink="/faq"><span [translate]="'GREATER.FAQ'"> </span></a>
                    </li>
                </ul>
            </div> -->
        </div>
    </nav>
</header>
<!-- Header before-login-header-->



<!--start after-login-header -->
<header class="after-login-header" *ngIf="loginTrue">
    <div class="topbar d-flex align-items-center">
        <nav class="navbar navbar-expand">
            <div class="mobile-toggle-menu" (click)="sideIcon()">
                <i class='gricon gr_ic_bars'></i>
            </div>

            <!-- <div class="search-block header-search-bar flex-grow-1" *ngIf="urlTrue">
                <div class="position-relative search-box">
                    <input type="text" class="form-control form-search-input" placeholder="{{ 'GREATER.SEARCH' | translate }}..." [(ngModel)]="search" (change)="searchText(1)">
                    <span class="position-absolute top-50 search-show translate-middle-y" *ngIf="!viewClose" (click)="searchText(1)"><i class='gricon gr_ic_search'></i></span>
                    <span class="position-absolute top-50 search-show translate-middle-y" *ngIf="viewClose" (click)="searchText(2)"><i class='gricon gr_ic_close'></i></span>
                </div>
            </div> -->

            <div class="top-menu ms-auto">
                <ul class="navbar-nav align-items-center">
                    <li class="nav-item mobile-search-icon">
                        <a class="nav-link ic-fill-btn" href="javascript:void(0);"> <i class='gricon gr_ic_search'></i> </a>
                    </li>
                    <li class="nav-item dropdown dropdown-large header-notifications-box">
                        <a class="header-notifications-ic nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <span class="alert-count">{{UnreadCount}}</span>
                            <i class="gricon gr_ic_notification"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <a href="javascript:void(0);">
                                <div class="msg-header">
                                    <p class="msg-header-title">Notifications</p>
                                    <p class="msg-header-clear ms-auto" (click)="markRead('')">Marks all as read</p>
                                </div>
                            </a>
                            <div class="header-notifications-list">
                                <a class="dropdown-item" [class]="item.class" href="javascript:void(0);" *ngFor="let item of NotificationDetail">
                                    <div class="d-flex" (click)="getMarkRead(item)">
                                        <!-- <div class="notify white-color">
                                            <i class="gricon gr_ic_user"></i>
                                        </div> -->
                                        <div class="flex-grow-1">
                                            <h6 class="msg-name dark-color mb-2">{{item.tittle}}<span class="msg-time float-end">{{item.create_dt_utc_new}} </span></h6>
                                            <p class="msg-info" [title]="item.message">{{item.message}}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- <a href="javascript:void(0);">
                                <div class="text-center msg-footer">View All Notifications</div>
                            </a> -->
                        </div>
                    </li>
                </ul>
            </div>
            <div class="user-box dropdown">
                <a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img loading="lazy" [src]="loginImage" class="user-img border-radius100" alt="user avatar" style="border-radius: 50% !important;object-fit: cover !important;">
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                    <li><a class="dropdown-item" routerLink="/profile"><span [translate]="'GREATER.PROFILE'"> </span><i class="gricon gr_ic_user"></i></a>
                    </li>
                    <li><a class="dropdown-item" routerLink="/change-password"><span [translate]="'GREATER.PASSWORD_SECURITY'"> </span><i class="gricon gr_ic_louck"></i></a>
                    </li>
                    <li><a class="dropdown-item" routerLink="/faq"><span [translate]="'GREATER.FAQ'"> </span><i class="gricon gr_ic_faq"></i></a>
                    </li>
                    <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#CONFIRMPopup1"><span [translate]="'GREATER.LOGOUT'"> </span><i class="gricon gr_ic_logout_bracket"></i></a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</header>
<!--end after-login-header -->

<div class="modal fade" id="CONFIRMPopup1" tabindex="-1" aria-labelledby="CONFIRMPopup1Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content darkthird-bg border-radius10">
            <div class="modal-body">
                <div class="verify-header pb-3 pt-4 text-center">
                    <div class="py-4">
                        <img loading="lazy" src="../../../assets/images/inner_logo.png">
                    </div>
                    <h6 class="title white-color m-0 py-4"> <span [translate]="'GREATER.ARE_YOU_SURE_WANT_LOGOUT'"> </span> </h6>
                    <div class="py-4 d-flex justify-content-center">
                        <a routerLink="/" (click)="service.logOut();close()" class="btn gradient1-btn custom-btn me-2"> <span [translate]="'GREATER.YES'"> </span> </a>
                        <a class="btn gradient1-btn custom-btn ms-2" (click)="close()"> <span [translate]="'GREATER.NO'"> </span> </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>